import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-flash-sharp",
  "use": "icon-flash-sharp-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" class=\"ionicon\" viewBox=\"0 0 512 512\" id=\"icon-flash-sharp\"><title>Flash</title><path d=\"M432 208H288l32-192L80 304h144l-32 192z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol